/**
 * Product card swatch color component
 *
 * @module product-card-swatch-color
 * @version 1.0.0
 * @extends HTMLElement
 */

customElements.component = 'product-card-swatch-color';

if(!customElements.get(customElements.component)) {

    class productCard extends HTMLElement {

        /**
         * Web component constructor
         *
         * @constructor
         */
        constructor() {

            super();


            window.theme.product.loadProduct(this.dataset.handle, true).then(product => {
                this.render(product);
                this.initEvents(product);
            });

            this.addToShowroomBtn = this.closest(".product-grid__item, .swiper-slide")?.querySelector(".js-add-to-showroom-btn");
        }

        /**
         * Render component in the DOM
         *
         * @param {object} product Product data.
         * @returns {undefined}
         */
        render(product) {
            if(product.options.length) {
                (product.options).forEach(option => {
                    if((option.name).toLowerCase() == "color") {
                        let html =  "";
                        this.options = option.values;

                        let path = window.location.pathname.split("/").pop();

                        // check if is sales page
                        let isSales = false;
                        if (path == "sale" || path == "sales") {
                            isSales = true;
                        }

                        if(option.values.length > 1) {

                            let activeValue = this.getRenderedColor(product, option),
                                visibleValues = this.getVisibleValues(option.values, activeValue);

                            visibleValues.forEach((value, index) => {
                                let isActive = (activeValue) ? value === activeValue : index === 0;
                                let isSalesOption = false;

                                if (isSales) {
                                    // find first variant of this color
                                    let variant = this.getVariantByColor(product, window.theme.handleize(value));

                                    if (variant && variant.compare_at_price) {
                                        isSalesOption = true;
                                    }
                                }

                                if ((!isSales || isSales && isSalesOption)) {
                                    let handle_color_value = window.theme.handleize(value);
                                    let swatchObj = (window.theme.hex_swatches.colors.find( item => {return item.handle_title == handle_color_value})) || "";

                                    if (swatchObj && swatchObj !== "") {
                                        const colorName = swatchObj.handle_title ? swatchObj.handle_title.toUpperCase().replaceAll("-", " ") : value;
                                        let buttonClass = "product-card__color-swatch block w-4 h-4 border-x border-y border-solid border-grey mr-2";
                                        if (isActive) buttonClass += " active";
                                        let ariaLabel = swatchObj.handle_title || value;
                                        let dataAttr = swatchObj.handle_title || value;

                                        if (isActive) {
                                            this.addToShowroomBtn && this.addToShowroomBtn.setAttribute("data-color-name", colorName);
                                        }

                                        if (swatchObj.image) {
                                            html += `<button aria-label="${ariaLabel}" data-product-card-swatch="${dataAttr}" class="${buttonClass}" style="padding:0;background:none;">
                                                <span class="block w-full h-full overflow-hidden">
                                                    <img src="${swatchObj.image}" alt="${ariaLabel}" class="object-cover w-full h-full" />
                                                </span>
                                            </button>`;
                                        } else {
                                            html += `<button aria-label="${ariaLabel}" data-product-card-swatch="${dataAttr}" class="${buttonClass}" style="background-color: ${swatchObj.color};"></button>`;
                                        }
                                    } else {
                                        let buttonClass = "product-card__color-swatch block w-4 h-4 border-x border-y border-solid border-grey mr-2";
                                        if (isActive) buttonClass += " active";
                                        let dataAttr = swatchObj.handle_title || value;

                                        html += `<button aria-label="${dataAttr}" data-product-card-swatch="${window.theme.handleize(dataAttr)}" class="${buttonClass}" style="background-color: #ffffff;"></button>`;
                                    }
                                }
                            });

                            if (option.values.length > 5) {
                                html += `<span class="text-[10px]">+ ${option.values.length - 5} Color(s)</span>`;
                            }

                            this.innerHTML = html;
                        }
                    }
                });
            }
        }

        /**
         * Init events
         *
         * @param {object} product Product data.
         * @returns {undefined}
         */
        initEvents(product) {
            this.querySelectorAll("[data-product-card-swatch]").forEach(swatch => {
                const colorHandle = swatch.dataset.productCardSwatch;
                let images = [];

                if(colorHandle) {

                    (product.images).forEach(image => {
                        if (image.alt) {
                            let alt = image.alt.toLowerCase();
                            if (alt.includes('swatch')) return;

                            let altArray = alt.split('/');
                            let reference = (altArray[1]) ? altArray.slice(1).join('/').trim() : null;
                            if (!reference) return;

                            const refHandle = window.theme.handleize(reference);
                            if (refHandle === colorHandle && this.getMediaSrc(image)) {
                                images.push(image);
                            }
                        }
                    });

                    if (images.length > 2) {
                        images = images.slice(0, 2);
                    }

                    swatch.addEventListener("click", () => {
                        this.activeSwatch(swatch, product, images);
                        this.changePrice(product, colorHandle);
                        this.updateQuickViewVariant(product, colorHandle);
                    });

                }

            });
        }

        /**
         * Get the color the card markup was rendered with.
         * 
         * The card image and price come from Liquid's
         * selected_or_first_available_variant, so when the first color is sold out
         * the rendered color is not the first option value.
         * 
         * @param {object} product Product data.
         * @param {object} option Color option data.
         * @returns {string|null} Color option value.
         */
        getRenderedColor(product, option) {

            let position = option.position || ((product.options || []).indexOf(option) + 1),
                variantId = this.getRenderedVariantId(),
                variant = (variantId) ? (product.variants).find(item => item.id == variantId) : null;

            if (!variant) {
                variant = (product.variants).find(item => item.available);
            }

            return (variant) ? variant["option" + position] || null : null;
        }

        /**
         * Get the variant id the card markup was rendered with.
         * 
         * @returns {string|null} Variant id.
         */
        getRenderedVariantId() {

            let link = this.getCardScope().querySelector("a[href*='" + this.dataset.handle + "?variant=']");

            if (!link) return null;

            let match = link.getAttribute("href").match(/[?&]variant=(\d+)/);

            return (match) ? match[1] : null;
        }

        /**
         * Get the color values to render.
         * 
         * Only the first five colors are shown, so a rendered color sitting past
         * that cut off takes the last slot instead of leaving no active swatch.
         * 
         * @param {Array} values Color option values.
         * @param {string|null} activeValue Color the card was rendered with.
         * @returns {Array} Color values to render.
         */
        getVisibleValues(values, activeValue) {

            let visible = values.slice(0, 5);

            if (activeValue && values.includes(activeValue) && !visible.includes(activeValue)) {
                visible[visible.length - 1] = activeValue;
            }

            return visible;
        }

        /**
         * Get the closest ancestor holding this card.
         * 
         * The same product can be rendered more than once on a page (a grid plus a
         * carousel), so every lookup has to stay inside this card instead of
         * hitting the first match in the document.
         * 
         * @returns {object} Element to scope the card lookups to.
         */
        getCardScope() {

            let selector = "[data-product-card-image='" + this.dataset.handle + "']",
                node = this.parentElement;

            while (node && node !== document.body) {

                if (node.querySelector(selector)) return node;

                node = node.parentElement;
            }

            return document;
        }

        /**
         * Get the color option of a product.
         * 
         * @param {object} product Product data.
         * @returns {object|undefined} Color option data.
         */
        getColorOption(product) {

            return (product.options || []).find(option => {
                return option.name && option.name.toLowerCase() == "color";
            });
        }

        /**
         * Get a usable image src from a media object.
         * 
         * Video media carry no src of their own, only a preview image, so reading
         * media.src directly leaves the card with an undefined source.
         * 
         * @param {object} media Media data.
         * @returns {string|null} Image src.
         */
        getMediaSrc(media) {

            if (!media) return null;

            return media.src || (media.preview_image && media.preview_image.src) || null;
        }

        /**
         * Resize an image src to the product card format.
         * 
         * @param {string} src Image src.
         * @returns {string} Resized image src.
         */
        getCardImageSrc(src) {

            if (!src) return src;

            let ext = window.theme.file.getExtension(src);

            if (!ext) return src;

            return src.replace(new RegExp(ext.replace('.', '\\.') + '(?=\\?|$)'), '_600x900_crop_center' + ext);
        }

        /**
         * active Swatch
         *
         * @param {object} swatch Swatch data.
         * @param {object} product Product data.
         * @param {Array} images Images of the swatch color.
         * @returns {undefined}
         */
        activeSwatch(swatch, product, images) {

            if (images.length) {

                let scope = this.getCardScope(),
                    image = scope.querySelector("[data-product-card-image='" + product.handle + "'] img"),
                    hoverImage = scope.querySelector("[data-product-card-image-hover='" + product.handle + "'] img");

                if (image) {
                    image.src = this.getCardImageSrc(this.getMediaSrc(images[0]));
                }

                if (hoverImage) {
                    hoverImage.src = this.getCardImageSrc(this.getMediaSrc(images[1] || images[0]));
                }
            }

            this.setActiveSwatch(swatch);
        }

        /**
         * Mark a swatch as the active one and sync the showroom color name.
         *
         * @param {object} swatch Swatch element.
         * @returns {undefined}
         */
        setActiveSwatch(swatch) {
            this.querySelectorAll("[data-product-card-swatch]").forEach(item => {
                item.classList.remove("active");
            });

            swatch.classList.add("active");

            const colorName = swatch.dataset.productCardSwatch.toUpperCase().replaceAll("-", " ");

            this.addToShowroomBtn && this.addToShowroomBtn.setAttribute("data-color-name", colorName);
        }

        /**
         * Find the variant that matches a handleized color value.
         *
         * @param {object} product Product data.
         * @param {string} colorHandle Handleized color value.
         * @returns {object|null} Variant data.
         */
        getVariantByColor(product, colorHandle) {
            if (!colorHandle || !product.variants) return null;

            let colorOption = (product.options || []).find(option => {
                return option && option.name && option.name.toLowerCase() === "color";
            });

            if (!colorOption) return null;

            let position = colorOption.position || (product.options.indexOf(colorOption) + 1);
            let optionKey = "option" + position;

            let matches = (product.variants).filter(variant => {
                return variant[optionKey] && window.theme.handleize(variant[optionKey]) === colorHandle;
            });

            if (!matches.length) return null;

            return matches.find(variant => variant.available) || matches[0];
        }

        /**
         * Keep the quick view triggers of this card pointing at the selected color.
         *
         * @param {object} product Product data.
         * @param {string} colorHandle Handleized color value.
         * @returns {undefined}
         */
        updateQuickViewVariant(product, colorHandle) {
            let variant = this.getVariantByColor(product, colorHandle);

            if (!variant) return;

            let card = this.getCardScope();

            if (!card) return;

            card.querySelectorAll("component-quickview-trigger[data-handle='" + product.handle + "']").forEach(trigger => {
                trigger.dataset.variantId = variant.id;
            });
        }

        /**
         * change price
         *
         * @param {object} product Product data.
         * @param {string} colorHandle Handleized color value.
         * @returns {undefined}
         */
        changePrice(product, colorHandle) {

            let priceComponent = this.getCardScope().querySelector("price-component[data-handle='" + product.handle + "']"),
                variant = this.getVariantByColor(product, colorHandle);

            if (priceComponent && variant) {
                const priceEl = priceComponent.querySelector("[data-price]");
                const compareAtPriceEl = priceComponent.querySelector("[data-compareatprice]");

                if (priceEl) {
                    priceEl.innerHTML = window.theme.money.format(variant.price);
                }

                if (compareAtPriceEl) {
                    if (variant.compare_at_price) {
                        compareAtPriceEl.innerHTML = window.theme.money.format(variant.compare_at_price);
                    } else {
                        compareAtPriceEl.innerHTML = " ";
                    }
                }
            }
        }

    }

    customElements.define(customElements.component, productCard);
}
